// extracted by mini-css-extract-plugin
module.exports = {"updateInfoWrapper":"UpdateTermsInfo_updateInfoWrapper__AP5tk","info":"UpdateTermsInfo_info__23gnr"};